import { useEffect, useState } from "react";
import { LoaderSreen } from "../../../../common/components/molecule/Loader/Loader";
import ErrorScreenApp from "../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";
import { useSingleChangeUserPasswordRequest } from "../../hooks/useChangeUserPasswordRequest";
import { ResetPasswordUserFormView } from "./RssetPasswordUserFormView";

import ValidatedStateDisplay from "../../../../common/components/organisme/ValidatedStateDisplay/ValidatedStateDisplay";
import useNavigationApp from "../../../../navigation/useNavigationApp";


export interface  FormDataResetPassword {
    password?: string;
    confirmPassword?: string;

 }

 export interface ErrorStatusResetPassword {
    isErrorPassword: boolean;
    isErrorConfirmPassword: boolean;
    allValid?: boolean;
    messageError?: string;
    
 }


  const checkValidity = (formData : FormDataResetPassword) => {
       
        const isErrorStatus : ErrorStatusResetPassword = {
            isErrorPassword: false,
            isErrorConfirmPassword: false,
            allValid : true,
            messageError: "",
        };

        let messageError : string[] = [];
        

        if ( !formData.password) {
       
            isErrorStatus.isErrorPassword = true;
            isErrorStatus.allValid = false;
            messageError.push("Veuillez saisir un mot de passe valide");
       
        }

        if ( !formData.confirmPassword) {
              messageError.push("Veuillez confirmer votre mot de passe");
            isErrorStatus.isErrorPassword = true;
            isErrorStatus.allValid = false;
  
         
        }
        if (formData.password !== formData.confirmPassword) {
              messageError.push("Les mots de passe ne correspondent pas");
            isErrorStatus.isErrorPassword = true;
            isErrorStatus.isErrorConfirmPassword = true;
            isErrorStatus.allValid = false;
       
        }

        if (messageError.length > 0) {
            isErrorStatus.messageError = messageError.join(", ");
        }

        return isErrorStatus;

    }


const INITIAL_IS_VALID_STATUS : ErrorStatusResetPassword = {
    isErrorPassword: false,
    isErrorConfirmPassword: false,
    allValid: true,
    messageError: "",
}
export const ResetUserPasswordFormPresenter = () => {

    const [formData, setFormData] = useState<FormDataResetPassword>({
        password: undefined,
        confirmPassword: undefined,
    });
    const [errorStatus, setErrorStatus] = useState<ErrorStatusResetPassword>({
        isErrorPassword: false,
        isErrorConfirmPassword: false,
        allValid: true,
        messageError: "",
    });

    const navigate = useNavigationApp();

    const [isDone, setIDone] = useState(false);
    const handleSetFormData = (key: keyof FormDataResetPassword, value: string) => {
        setFormData((prev) => ({
            ...prev,
            [key]: value,
        }));
    }

    
  
    
    const { getSingleChangeUserPasswordRequest, changeUserPawssword } = useSingleChangeUserPasswordRequest(); 
    
    useEffect(() => {
        if (getSingleChangeUserPasswordRequest.isError) {
            setErrorStatus({
                ...INITIAL_IS_VALID_STATUS,
                messageError: getSingleChangeUserPasswordRequest.error?.message || "Une erreur est survenue",
                allValid: false,
            });
        }
    },[changeUserPawssword.error]) // eslint-disable-line react-hooks/exhaustive-deps
    if (getSingleChangeUserPasswordRequest.isLoading) {
        return <LoaderSreen heigth={100} />;
    }

    if (getSingleChangeUserPasswordRequest.isError) {
        return <ErrorScreenApp axiosError={getSingleChangeUserPasswordRequest.error}  message="Désolé, vorte demande de changement de mot de passe n'est plus disponible."/>;
    }

    if (getSingleChangeUserPasswordRequest.data?.rpr_status !== "PENDING") {
        return <ErrorScreenApp message="Désolé, vorte demande de changement de mot de passe a expirée" title="Demande expirée"/>;
    }


  if (isDone) {
    return <ValidatedStateDisplay  
      validationMessage="Votre mot de passe a été modifié avec succès"
      labelBtn="Accueil"
      onClickBtn={() => {
        navigate.goToHome();
      }}
      marginLeft="-20%"
    />;
  }
   
    const handleChangePassword = () => {
        const isErrorStatus = checkValidity(formData);

        if (!getSingleChangeUserPasswordRequest.data?.rpr_id) {
            setErrorStatus({
                ...INITIAL_IS_VALID_STATUS,
                messageError: "Aucune demande de changement de mot de passe trouvée",
                allValid: false,
            });
            return;
        }

        if (isErrorStatus.allValid && getSingleChangeUserPasswordRequest.data?.rpr_id ) {
            changeUserPawssword.mutate({
                requestId: getSingleChangeUserPasswordRequest.data?.rpr_id,
                newPassword: formData.password || "",
                callback: ({ result, error }) => {
                    if (result) {
                        setErrorStatus(INITIAL_IS_VALID_STATUS);
                        setFormData({ password: "", confirmPassword: "" });
                        setIDone(true);
                    } else {
                        setErrorStatus({
                            ...INITIAL_IS_VALID_STATUS,
                            messageError: error?.message || "Une erreur est survenue",
                        });
                    }
                },
            });
            return 
        }else {
            setErrorStatus(isErrorStatus);
        }

    }

    return (
        <ResetPasswordUserFormView 
            title="Réinitialiser votre mot de passe"
            description="Veuillez entrer votre nouveau mot de passe"
            submitLabel="Réinitialiser votre mot de passe"
            formData={formData}
            setFormData={handleSetFormData}
            errorStatus={errorStatus}
            handleSubmit={handleChangePassword}
            messageError={errorStatus.messageError}
            isLoading={changeUserPawssword.isLoading}
            maxWidth="500px"

        />
    )
}